import { useMemo } from 'react';

type UseSuggestionIndicesParams = {
  shouldShowHomeAddress: boolean;
  formattedAddress: string;
  temporaryAddress?: string | null;
  forceUseHomeAddress?: boolean;
};

type SuggestionIndices = {
  homeAddressIndex: number;
  temporaryAddressIndex: number;
  baseSuggestionsStartIndex: number;
};

/**
 * Hook to calculate the index position for each suggestion type in the dropdown.
 * Indices are calculated based on which special options (home address, temporary address)
 * are visible.
 */
export const useSuggestionIndices = ({
  shouldShowHomeAddress,
  formattedAddress,
  temporaryAddress,
  forceUseHomeAddress,
}: UseSuggestionIndicesParams): SuggestionIndices => {
  const homeAddressIndex = 0;

  const temporaryAddressIndex = useMemo(
    () => ((shouldShowHomeAddress || forceUseHomeAddress) && formattedAddress ? 1 : 0),
    [shouldShowHomeAddress, forceUseHomeAddress, formattedAddress]
  );

  const baseSuggestionsStartIndex = useMemo(() => {
    let offset = 0;
    if ((shouldShowHomeAddress || forceUseHomeAddress) && formattedAddress) {
      offset += 1;
    }
    if (temporaryAddress && forceUseHomeAddress) {
      offset += 1;
    }
    return offset;
  }, [shouldShowHomeAddress, forceUseHomeAddress, formattedAddress, temporaryAddress]);

  return {
    homeAddressIndex,
    temporaryAddressIndex,
    baseSuggestionsStartIndex,
  };
};
